<template>
  <div>
    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="`${url_banners_mobile}/images/mobile/banner_home.jpg`"
      ></BannerTopMobile>
    </div>
    <div class="d-flex justify-content-center" :style="`${user ? '' : 'margin-bottom: 50%'}`">
      <div v-if="user">
        <div>
          <div style="position: relative; text-align:center">
            <span class="font-backward session_name font-weight-bold" style="position: absolute; bottom: 10px; right: 0; left: 80px; color: white">
              {{user.name}}
            </span>
            <img class="img-session_name" src="@/assets/store/home/session_name.png" alt="">
          </div>
        </div>

        <form class=" text-center mt-50">

          <div class="form-group col-sm-12 text-center">
            <label for="new_password" class="color-blue font-general-r h5 font-weight-bold">
              Nueva contraseña
            </label>
            <input
              name="new_password"
              v-validate="'required'"
              data-vv-as="Nueva contraseña"
              v-model="passwords.new_password"
              type="password"
              class="input-nv"
              id="password"
              ref="new_password"
            >
            <br>
            <span v-show="errors.has('new_password')" class="w-100 text-danger mt-2">
              {{ errors.first("new_password") }}
            </span>
          </div>

          <div class="form-group col-sm-12 text-center">
            <label for="confirm_password" class="color-blue font-general-r h5 font-weight-bold">
              Confirmar nueva contraseña
            </label>
            <input
              name="confirm_password"
              v-validate="'required|confirmed:new_password'"
              data-vv-as="Confirmar contraseña"
              v-model="passwords.confirm_password"
              type="password"
              class="input-nv"
              id="confirm_password"
            >
            <br>
            <span v-show="errors.has('confirm_password')" class="w-100 text-danger mt-2">
              {{ errors.first("confirm_password") }}
            </span>
          </div>

          <v-btn
            @click="changePassword()"
            elevation="0"
            color="primary"
            class="nv-btn nv-btn-large mt-10 nv-btn-hover"
            :loading="loading"
          >
            CAMBIAR CONTRASEÑA
          </v-btn>

        </form>

      </div>
    </div>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

  </div>
</template>

<script>
import HomeService from '@/services/home.service'

export default {
  data() {
    return {
      url_banners_mobile: process.env.VUE_APP_URL_FILES,
      loading: false,
      overlay: false,

      user: null,

      passwords: {
        new_password: '',
        confirm_password: ''
      }
    }
  },
  methods: {
    async getUser(uuid) {
      this.overlay = true
      const { data:res } = await HomeService.getUser(uuid)
      if (res.success) {
        this.user = res.data
      } else {
        this.$swal({
          title: res.error,
          text: "",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "Continuar!"
        }).then(async result => {
          if(result.value) {
            location.href = '/recuperar-contraseña'
          }
        })
      }
      this.overlay = false
    },
    changePassword() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          try {
            this.loading = true
            const { data:res } = await HomeService.changePassword({
              new_password: this.passwords.new_password,
              confirm_password: this.passwords.confirm_password,
              uid: this.$route.query.uuid
            })

            if (res.success) {
              this.$swal({
                title: "Contraseña modificada exitosamente, presiona Continuar para iniciar sesión",
                text: "",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Continuar!",
                customClass: {
                  confirmButton: 'mr-1',
                }
              }).then(async result => {
                if(result.value) {
                  location.href = '/iniciar-sesion'
                }
              })

            } else {
              this.loading = false
              this.$swal({
                title: "¡Ops!, al parecer tu solicitud no es correcta, intenta recuperar la clave nuevamente",
                text: "",
                icon: "warning",
                showCancelButton: false,
                confirmButtonText: "Continuar!"
              }).then(async result => {
                if(result.value) {
                  location.href = '/recuperar-contraseña'
                }
              })
            }
          } catch (e) {
            this.loading = false
            this.$swal('Ops! Nieve de olla no esta disponible en este momento', '', 'warning');
          }
        }
      })
    }
  },
  mounted() {
    if (this.$route.query.uuid && this.$route.query.referer) {

      this.getUser(this.$route.query.uuid)

    } else {
      this.$swal({
        title: "¡Ops!, al parecer tu solicitud no es correcta, intenta recuperar la clave nuevamente",
        text: "",
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "Continuar!"
      }).then(async result => {
        if(result.value) {
          location.href = '/recuperar-contraseña'
        }
      })
    }
  }
}
</script>
